import {
  automatonSectionExtremityLayer,
  automatonSectionLayer,
  automatonSectionOutlineLayer,
} from '@components/map/layers/automatonSections/automatonSection.layer';
import { useMapContext } from '@components/map/MapContext';
import { createSensorLayerErrorToast } from '@components/ui/toaster/toaster';
import { useSelectorWithReplayMode } from '@hooks/useSelectorWithReplayMode';
import { selectAutomatonCabinetSectionLineFeatures } from '@redux/situation/monitoring.selectors';
import { isFeatureCollection } from '@utils/map/map.utils';
import { ErrorBoundary } from 'react-error-boundary';
import { Layer, Source } from 'react-map-gl/mapbox';

import { MapIdEnum, SourceNameEnum } from '@/types/map.types';

function AutomatonSectionLineLayerContent() {
  const { viewState } = useMapContext();
  const segmentLineFeatures = useSelectorWithReplayMode(selectAutomatonCabinetSectionLineFeatures, viewState.zoom);

  if (!isFeatureCollection(segmentLineFeatures)) return null;

  return (
    <Source id={SourceNameEnum.AUTOMATON_SECTION_LINES} type="geojson" data={segmentLineFeatures}>
      <Layer {...automatonSectionOutlineLayer} />
      <Layer {...automatonSectionLayer} />
      <Layer {...automatonSectionExtremityLayer} />
    </Source>
  );
}

export default function AutomatonSectionLineLayer() {
  const { mapId } = useMapContext();
  return mapId === MapIdEnum.REPLAY ? (
    <ErrorBoundary fallback={<></>} onError={() => createSensorLayerErrorToast(SourceNameEnum.AUTOMATON_SECTION_LINES)}>
      <AutomatonSectionLineLayerContent />
    </ErrorBoundary>
  ) : (
    <AutomatonSectionLineLayerContent />
  );
}
